export const GetChatAll = async regnum => {
  return fetch(`api/Chatting/GetAll/${regnum}`)
    .then(handleResponse)

    .then(response => response.json());
};
export const GetRecent = async  () => {
  return fetch(`api/Chatting/GetRecent`)
    .then(handleResponse)

    .then(response => response.json());
};

const handleResponse = response => {
  if (!response.ok) {
    if (response.status === 401) {
      // auto logout if 401 response returned from api
      console.log(this.props);
      window.location = "http://www.google.com";
    }

    return Promise.reject();
  }
  return Promise.resolve(response);
};



// WEBPACK FOOTER //
// ./src/pages/Chat/API.js